let form_id = 'without-manager-pin';
let interval;
let interval_hours;
let phone;
let pin;
export default {
    init() {
        this.getTimeStationModal();
        this.initModal();
        this.getTimeByPhone();
        this.punchTime();
        this.goPos();
    },
    getTimeStationModal() {
        $('.link-timestation').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'GET',
                url: '/get_time_station_modal',
                success: function (response) {
                    $('#time-station-form-modal .modal-body').html(response);

                    $('body #' + form_id + ' .div-phone input').mask('999-999-9999', {placeholder: '___-___-____'});
                    $('body #' + form_id + ' .div-pin input').mask('999999', {placeholder: '______'});

                    $('#time-station-form-modal').modal('show');
                }
            });
        });
    },
    initModal() {
        let change_inputs = function (e) {
            e.preventDefault();
            if ($('body #' + form_id + ' .div-phone input').val() === '' || $('body #' + form_id + ' .div-pin input').val() === '') {
                $('body #' + form_id + ' .btn-next').attr('disabled', 'disabled');
            } else {
                $('body #' + form_id + ' .btn-next').removeAttr('disabled');
            }
        };
        $('body').on('keyup', '#' + form_id + ' .div-phone', change_inputs);
        $('body').on('keyup', '#' + form_id + ' .div-pin', change_inputs);
    },
    getTimeByPhone() {
        let $this = this;
        $('body').on('click', '#' + form_id + ' .btn-next', function (e) {
            e.preventDefault();
            $('body #time-station-errors').html('');
            $.ajax({
                type: 'GET',
                url: '/get_last_time_by_phone',
                data: ({
                    phone: $('body #' + form_id + ' .div-phone input').val(),
                    pin: $('body #' + form_id + ' .div-pin input').val(),
                }),
                success: function (response) {
                    phone = $('body #' + form_id + ' .div-phone input').val();
                    pin = $('body #' + form_id + ' .div-pin input').val();
                    $('body #' + form_id + ' .btn-next').addClass('d-none');
                    $('body #' + form_id + ' .div-phone').addClass('d-none');
                    $('body #' + form_id + ' .div-pin').addClass('d-none');
                    $('body .title .subtitle').addClass('d-none');
                    $('body #' + form_id + ' .times').html(response.view);

                    let selector;
                    let date = new Date(response.date_now);
                    if (response.change_in) {
                        selector = 'body #' + form_id + ' .times .in span';
                        $('body #' + form_id + ' .btn-start-work').removeClass('d-none');
                    } else {
                        selector = 'body #' + form_id + ' .times .out span';
                        $('body #' + form_id + ' .btn-finish-work').removeClass('d-none');
                        if (response.access_to_pos) {
                            $('body #' + form_id + ' .btn-go-pos').removeClass('d-none');
                            $('body #' + form_id + ' .close-modal').removeClass('d-none');
                        }
                        let date_hours = date;
                        interval_hours = setInterval(function () {
                            let time_hours = date_hours.getTime() + 1000;
                            date_hours = new Date(time_hours);
                            let date_in = new Date($('body #' + form_id + ' .times .in #time_in').text());
                            let diff_date = Math.floor(Math.abs(date_hours.getTime() - date_in.getTime()) / (1000 * 60));
                            let hours = Math.floor(diff_date / 60);
                            let minutes = diff_date - (hours * 60);
                            let date_string = '';
                            if (hours > 0) { date_string += hours + 'h '; }
                            if (minutes > 0 || minutes === 0 && hours === 0) { date_string += minutes + 'm'; }
                            $('body #' + form_id + ' .times .hours span').html(date_string);
                        }, 1000);
                    }
                    interval = setInterval(function () {
                        let time = date.getTime() + 1000;
                        date = new Date(time);
                        $(selector).html($this.dateFormat(date));
                    }, 1000);
                },
                error: function (response) {
                    let errors = '<div class="alert alert-danger">';
                    if (response.responseJSON.error) {
                        errors += response.responseJSON.error;
                    }
                    if (response.responseJSON.errors) {
                        errors += 'Some errors occurred:<br /><ul>';

                        $.each(response.responseJSON.errors, function (index, value) {
                            errors += '<li>' + value + '</li>';
                        });
                        errors += '</ul>';
                    }
                    errors += '</div>';
                    $('body #time-station-errors').html(errors);
                }
            })
        });
    },
    punchTime() {
        $('body').on('click', '#' + form_id + ' .btn-punch-it', function (e) {
            e.preventDefault();
            clearInterval(interval);
            clearInterval(interval_hours);
            $.ajax({
                type: 'POST',
                url: '/worker_pin',
                data: ({
                    phone: phone,
                    pin: pin,
                    is_modal: true,
                }),
                success: function (response) {
                    $('#time-station-form-modal .modal-body').html(response.view);
                    if (response.url !== null) {
                        setTimeout(function () {
                            location.href = response.url;
                        }, 1000 * 3);
                    }
                }
            });
        });
    },
    goPos() {
        $('body').on('click', '.btn-go-pos', function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/pos_login',
                data: ({
                    phone: phone,
                    pin: pin,
                }),
                success: function (response) {
                    if (response.url !== null) {
                        location.href = response.url;
                    }
                },
                error: function (response) {
                    if (response.error !== null) {
                        $('#time-station-errors').html('<div class="alert alert-danger">' + response.responseJSON.error + '</div>');
                    }
                }
            });
        });
    },
    dateFormat(date) {
        let options = {month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', second: '2-digit'};
        return new Intl.DateTimeFormat('en-US', options).format(date);
     },
}
